import { RotatingLines } from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import Constants from "../../../Constants";
import SuccessMessage from "../../../components/SuccessMessage";
import jQuery from "jquery";

export default function UberflipCredential (props) {

  const clientIdRef = useRef(null);
  const clientSecretRef = useRef(null);

  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [clientId, setClientId] = useState(clientIdRef.current?.value);
  const [clientSecret, setClientSecret] = useState(clientSecretRef.current?.value);

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
        //props.closePopup();
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateEloquaCredButton = jQuery("#validate-credential");
    if (clientId?.length > 0 && clientSecret?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateEloquaCredButton?.attr("disabled", "true")
    }
  }, [clientId, clientSecret]);

  const onChnageInputFields = () => {
    setClientId(clientIdRef.current?.value);
    setClientSecret(clientSecretRef.current?.value);
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
    </div> 
    {errorMessages?.length > 0 &&
      <><ul id="brightcoveServerError" className="list-error">
      {errorMessages?.map(error => {
        return (<li>{JSON.stringify(error)}</li>) 
      })}
      </ul><br/></>
    }
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}

      <div className="global-dropdown-block mr-0">
        <label>Client ID</label>
        <div className="global-dropdown-select">
          <input id="uberflip-client-id-input" type="text" className="form-control-sm" placeholder="Client Id" defaultValue={credentialData?.credentials?.CLIENT_ID} 
          ref={clientIdRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Client Secret</label>
        <div className="global-dropdown-select">
          <input id="uberflip-client-secret-input" type="text" className="form-control-sm" placeholder="Client Secret" defaultValue={credentialData?.credentials?.CLIENT_SECRET} 
          ref={clientSecretRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
    </>
  )
}


